exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#bind-point[data-v-a3327ffa]{height:390px;width:530px;left:8px;bottom:6px;background-color:hsla(0,0%,100%,.76);border-radius:4px;z-index:99}#bind-point .table-header[data-v-a3327ffa]{margin:10px 0}#bind-point .point-table[data-v-a3327ffa]{height:calc(100% - 75px)}[data-v-a3327ffa] .el-table__body-wrapper{background-color:transparent!important}.el-button+.el-button[data-v-a3327ffa]{margin-left:10px}.close-btn[data-v-a3327ffa]{top:5px;right:5px}", ""]);

// exports
